export const TIMESHEET_USER = "TIMESHEET_USER"
export const TIMESHEET_USER_SUCCESS = "TIMESHEET_USER_SUCCESS"
export const TIMESHEET_USER_ERROR = "TIMESHEET_USER_ERROR"

export const PROJECT_LIST = "PROJECT_LIST"
export const PROJECT_LIST_SUCCESS = "PROJECT_LIST_SUCCESS"
export const PROJECT_LIST_ERROR = "PROJECT_LIST_ERROR"

export const CLIENT_LIST = "CLIENT_LIST"
export const CLIENT_LIST_SUCCESS = "CLIENT_LIST_SUCCESS"
export const CLIENT_LIST_ERROR = "CLIENT_LIST_ERROR"

// SCREEN VERIFIED MODAL
export const SCREEN_VERIFIED = "SCREEN_VERIFIED"
export const SCREEN_VERIFIED_SUCCESS = "SCREEN_VERIFIED_SUCCESS"
export const SCREEN_VERIFIED_ERROR = "SCREEN_VERIFIED_ERROR"

// Activity user
export const ACTIVITY_SUMMARY = "ACTIVITY_SUMMARY"
export const ACTIVITY_SUMMARY_SUCCESS = "ACTIVITY_SUMMARY_SUCCESS"
export const ACTIVITY_SUMMARY_ERROR = "ACTIVITY_SUMMARY_ERROR"

//Excludescreen my hours page
export const EXCLUDE_SCREEN = "EXCLUDE_SCREEN"
export const EXCLUDE_SCREEN_SUCCESS = "EXCLUDE_SCREEN_SUCCESS"
export const EXCLUDE_SCREEN_ERROR = "EXCLUDE_SCREEN_ERROR"

//ExcludescreenLogs my hours page
export const EXCLUDE_SCREEN_LOGS = "EXCLUDE_SCREEN_LOGS"
export const EXCLUDE_SCREEN_LOGS_SUCCESS = "EXCLUDE_SCREEN_LOGS_SUCCESS"
export const EXCLUDE_SCREEN_LOGS_ERROR = "EXCLUDE_SCREEN_ERROR"

//Teams based creenLogs my hours page
export const TEAM_GET_SCREEN_LOGS = "TEAM_GET_SCREEN_LOGS"
export const TEAM_GET_SCREEN_LOGS_SUCCESS = "TEAM_GET_SCREEN_LOGS_SUCCESS"
export const TEAM_GET_SCREEN_LOGS_ERROR = "TEAM_GET_SCREEN_ERROR"

export const FILTERED_SCREEN_IMAGES = "FILTERED_SCREEN_IMAGES"


//hoursReport page verify screens list GetProjectSummaryReportScreens
export const GET_PROJECT_SUMMARY_REPORT_SCREEN = "GET_PROJECT_SUMMARY_REPORT_SCREEN"
export const GET_PROJECT_SUMMARY_REPORT_SCREEN_SUCCESS = "GET_PROJECT_SUMMARY_REPORT_SCREEN_SUCCESS"
export const GET_PROJECT_SUMMARY_REPORT_SCREEN_ERROR = "GET_PROJECT_SUMMARY_REPORT_SCREEN_ERROR"

//hoursReport page verify report list GetProjectSummaryWorkReports
export const GET_PROJECT_SUMMARY_WORK_REPORTS = "GET_PROJECT_SUMMARY_WORK_REPORTS"
export const GET_PROJECT_SUMMARY_WORK_REPORTS_SUCCESS = "GET_PROJECT_SUMMARY_WORK_REPORTS_SUCCESS"
export const GET_PROJECT_SUMMARY_WORK_REPORTS_ERROR = "GET_PROJECT_SUMMARY_WORK_REPORTS_ERROR"